import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import NFTNav from "../components/NavComponents/NFTNav";
import PerksList from "../components/desktop/PerksList";
import { io } from 'socket.io-client';
import { mintNFT, sendMessagePerk, airdropNFT } from '../utils/backendUtils';
import SocialConnectModalComponent from '../components/NavComponents/SocialConnectModalComponent'
import { getLoginInformation,
    setPaymentDetails,
    setWalletDetails,
    setSocialHandleInformation
} from '../utils/loginHelper';
import eventBus from '../utils/globalPubSub';
import Lottie from 'react-lottie';
import animationData from '../assets/loader.json';
import { useHistory } from "react-router-dom";
import { fethchGlipBox } from '../utils/backendUtils';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 96vh;
    flex-direction: column;
  }
`;

const Title = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 36px;

    display: flex;
    align-items: center;

    color: #FFFFFF;
    text-align: center;

`;

const Price = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    display: flex;
    align-items: center;

    color: #FFFFFF;
`;

const Subtitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: 600;
    font-size: 15.5866px;
    line-height: 120%;
    /* or 19px */
   
    letter-spacing: -0.03em;

    color: #FFFFFF;

    color: #fff;
   
`;


const ActionBoxTitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: bold;
    color: #FFFFFF;
    text-transform: uppercase;
`;

const ActionBoxSubtitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 145%;
    /* or 20px */

    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.4;
    margin-top: 15px;
    margin-bottom: 24px;
`;


const ActionBox = styled.div`
    background: rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    color: #FFFFFF;
    padding: 50px 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    opacity: 0.8
    align-items: flex-end;
    padding-left: 50px;
  }
`;


const GradientButton = styled.div`
    background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
    border-radius: 12px;
    padding: 13px;
    width: 100%;
    color: #fff;
    display: flex;
    justify-content: center;
    margin-top: 31px;
`;


const Description = styled.div`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    opacity: 0.4;
    margin-bottom: 32px;
`;


const BotBar = styled.div`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background: rgba(255, 255, 255, 0.04);
    padding: 15px;
    flex-direction: column;
    width: 100%;
`;

const BotBarTitle = styled.span`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.4;
    margin-bottom: 5px;
`;

const BotBarCount = styled.span`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    display: flex;
    align-items: center;
    text-align: right;

    color: #FFFFFF;

`;

export default function ClaimGlipBox(props) {
    const [socialConnectModalOpen,
        setSocialConnectModalOpen] = useState(false);
    const [connected, setIsConnected] = useState(false);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({});
    const {username} = useParams();
    const history = useHistory();
    const [glipbox, setGlipbox] = useState();
    
    // Fetch data for remaing glipboxes
    useEffect(() => {
        const fetchApi = async () => {
            const glipboxData = await fethchGlipBox(username);
            console.log('glipboxdata==============', glipboxData)
            if(glipboxData.success)
                setGlipbox(glipboxData);
        };

        fetchApi();
    }, []);

    
    const handleLogin = async (loginDetails)=>{
        setIsConnected(true);
        setUser(loginDetails.user);        
    }

    const handleLogout = ()=> {
        setIsConnected(false);
        setUser({});
        setSocialConnectModalOpen(false)
    }

    
    const handleClaimButtonClick = async () => {
        setLoading(true)        
        console.log('setSocialConnectModalOpen(true)')
        let loginData = getLoginInformation();
        console.log(loginData)
        if(loginData){
            // handleLogin(loginData);
            // Make backend API call to mint NFT
            console.log(loginData)
            const response = await airdropNFT(username, loginData.user);
            console.log('airdtop============', response)
            if(response.success)
                history.push(`/address/${loginData.user.username}`)
            console.log('mint api call')
        }
        setSocialConnectModalOpen(true);
    };

    useEffect(()=>{
        let loginData = getLoginInformation();
        if(loginData){
            handleLogin(loginData);
        }
        eventBus.on("user-logged-in",(data)=>{
            handleLogin(data);
        });
        eventBus.on("user-logged-out",()=>{
            handleLogout();
        })
        return ()=>{
            eventBus.remove("user-logged-in");
            eventBus.remove("user-logged-out");
        }
    },[]);

    
    return (
        <>
        <Mobile>
            <NFTNav		    
                userChainId={1}
                showTabs={false}
                ownedTab={false}
            />
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', height: '65vh', alignSelf: 'center', flexDirection: 'column'}}>
                <div style={{display: 'flex', flex: 2, flexWrap: 'wrap'}}>
                    <video
                        autoPlay
                        loop
                        style={{width: '100%', zIndex: -1, maxHeight: 260}}
                        src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/draft170_4.mp4'}
                    ></video>
                </div>
                <div style={{padding: 24, width: '100%'}}>
                    <div style={{
                        width: '100%',
                        borderRadius: 12,
                        display: 'flex',
                        flex: 1,
                        background: 'rgba(255, 255, 255, 0.08)',
                        alignItems: 'center',
                        flexDirection: 'column',
                        }}>
                        <Title style={{marginTop: 73, marginBottom: 18}}>{username}'s <br></br>Glipbox</Title>
                        <Description>Mysterious box... <br></br>What will it bring<br></br>to it’s holder?</Description>

                        {loading ?
                         <GradientButton style={{marginBottom: 32, width: '80%', padding: 3}}><Lottie style={{}}
                            options={defaultOptions}
                            height={40}
                            width={40}
                        /></GradientButton> :
                        <GradientButton onClick={() => handleClaimButtonClick()} style={{marginBottom: 32, width: '80%'}}>CLAIM BOX
                        </GradientButton>
                        }

                        <BotBar>
                            <BotBarTitle>Boxes Claimed</BotBarTitle>
                            {glipbox && <BotBarCount>{glipbox.data.minted}/{glipbox.data.supply} minted</BotBarCount>}
                        </BotBar>
                    </div>
                </div>
            </div>
        </Mobile>       
        <Desktop style={{}}>
            <NFTNav		    
                userChainId={1}
                showTabs={false}
                ownedTab={false}
            />
            {/* <Title style={{justifyContent: 'center', width: '100%', marginTop: 40}}>CLAIM YOUR NFT PERKS</Title> */}
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', height: '65vh', alignSelf: 'center',}}>
                <div style={{display: 'flex', flex: 2, flexWrap: 'wrap'}}>
                    <video
                        autoPlay
                        loop
                        style={{width: '100%', zIndex: -1}}
                        src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/draft170_4.mp4'}
                    ></video>
                </div>
                <div style={{position: 'relative', right: 120, width: 370, borderRadius: 12, display: 'flex', flex: 1, background: 'rgba(255, 255, 255, 0.08)', alignItems: 'center', flexDirection: 'column'}}>
                    <Title style={{marginTop: 73, marginBottom: 18}}>{username}'s <br></br>Glipbox</Title>
                    <Description>Mysterious box... <br></br>What will it bring<br></br>to it’s holder?</Description>

                    <GradientButton onClick={() => handleClaimButtonClick()} style={{marginBottom: 32, width: '80%'}}>CLAIM BOX</GradientButton>

                    <BotBar>
                        <BotBarTitle>Boxes Claimed</BotBarTitle>
                        {glipbox && <BotBarCount>{glipbox.data.minted}/{glipbox.data.supply} minted</BotBarCount> }
                    </BotBar>
                </div>
            </div>
            
            <br></br>
            {!connected && <SocialConnectModalComponent
                isOpen={socialConnectModalOpen}
                setIsOpen={(val)=>{setSocialConnectModalOpen(val)} }
            >
            </SocialConnectModalComponent>}
        </Desktop>
        </>
    );
}

